var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dp-reminder-container clearfix" },
    [
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        !_vm.activeSetting
          ? _c(
              "div",
              { key: "main" },
              [
                _vm.reminder.has_reminder && !_vm.reminder.snooze_duration_days
                  ? _c(
                      "div",
                      {
                        staticClass: "dp-reminder-dropdown dropdown",
                        class: ["has-reminder", { open: _vm.isDropdownActive }]
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "main-trigger btn-link dropdown-toggle",
                            on: { click: _vm.toggleDropdown }
                          },
                          [
                            _c("span", { staticClass: "bell-icon" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "label" }, [
                              _vm._v("Set reminders")
                            ]),
                            _vm._v(" "),
                            _vm.reminder.has_reminder
                              ? _c("span", { staticClass: "status" }, [
                                  _vm._v("On")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("i", { staticClass: "arrow" })
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isDropdownActive
                          ? _c("ul", { staticClass: "dropdown-menu" }, [
                              _c("li", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-link",
                                    attrs: { id: "reminder-snooze-trigger" },
                                    on: { click: _vm.openSnoozeSetting }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Snooze\n            "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn-link set-reminder-trigger",
                                    on: { click: _vm.openReminderSetting }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Reminder settings\n            "
                                    )
                                  ]
                                )
                              ])
                            ])
                          : _vm._e()
                      ]
                    )
                  : [
                      _c(
                        "button",
                        {
                          class: [
                            "main-trigger",
                            "btn-link",
                            {
                              "is-snoozed": _vm.reminder.snooze_duration_days,
                              "not-set": _vm.reminder.has_reminder !== true
                            }
                          ],
                          on: { click: _vm.openSetting }
                        },
                        [
                          _c("span", { staticClass: "bell-icon" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "label" }, [
                            _vm._v("Set reminders")
                          ]),
                          _vm._v(" "),
                          _vm.reminder.snooze_duration_days
                            ? _c("span", { staticClass: "status" }, [
                                _vm._v("Snoozed")
                              ])
                            : _vm._e()
                        ]
                      )
                    ]
              ],
              2
            )
          : _c(
              "div",
              { key: "setting" },
              [
                _c(
                  "button",
                  { staticClass: "close", on: { click: _vm.closeSetting } },
                  [_vm._v("Close")]
                ),
                _vm._v(" "),
                _vm.activeSetting === "reminder"
                  ? [
                      _c("header", [
                        _c("h3", [_vm._v("Set reminders")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("Learn the big ideas, one day at a time.")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-content" },
                        [
                          _vm._l(_vm.reminder.tracks, function(track) {
                            return _c(
                              "fieldset",
                              { key: track.id, staticClass: "b-vspace-s" },
                              [
                                _c(
                                  "label",
                                  { staticClass: "checkbox choose-track" },
                                  [
                                    _c("span", { staticClass: "bell-icon" }),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.trackIds,
                                          expression: "trackIds"
                                        }
                                      ],
                                      attrs: {
                                        type: "checkbox",
                                        name: "tracks"
                                      },
                                      domProps: {
                                        value: track.id,
                                        checked: Array.isArray(_vm.trackIds)
                                          ? _vm._i(_vm.trackIds, track.id) > -1
                                          : _vm.trackIds
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.trackIds,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = track.id,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.trackIds = $$a.concat([
                                                  $$v
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.trackIds = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.trackIds = $$c
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "b-checkbox" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v(_vm._s(track.name))
                                    ])
                                  ]
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("fieldset", { staticClass: "time" }, [
                            _c("span", { staticClass: "time-icon" }),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.sendTime,
                                    expression: "sendTime"
                                  }
                                ],
                                attrs: { name: "send_time" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.sendTime = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.reminder.times, function(time) {
                                return _c(
                                  "option",
                                  {
                                    key: time.name,
                                    domProps: {
                                      value: time.time,
                                      selected: time.selected
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(time.name) +
                                        "\n              "
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "/profile/selecttimezone/",
                                  target: "blank"
                                }
                              },
                              [_vm._v(" Change timezone ")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n            New problems are released at\n            " +
                                _vm._s(
                                  _vm.reminder
                                    .time_problems_are_released_in_timezone
                                ) +
                                "\n          "
                            )
                          ])
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "footer",
                        [
                          _c(
                            "Button",
                            {
                              staticClass: "btn btn-outline",
                              attrs: { loading: _vm.saveInProgress },
                              on: { click: _vm.save }
                            },
                            [_vm._v("Save")]
                          )
                        ],
                        1
                      )
                    ]
                  : _vm.activeSetting === "snooze"
                  ? [
                      _c("header", [
                        _c("h3", [_vm._v("Snooze?")]),
                        _vm._v(" "),
                        _c("p", [_vm._v("For how long?")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-content content b-vspace-0" },
                        [
                          _c("fieldset", { staticClass: "b-vspace-s" }, [
                            _c(
                              "label",
                              { staticClass: "checkbox radio choose-snooze" },
                              [
                                _c("span", { staticClass: "time-icon" }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.snoozeDuration,
                                      expression: "snoozeDuration"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    name: "snooze_days",
                                    value: "7"
                                  },
                                  domProps: {
                                    checked: _vm.snoozeDuration == 7,
                                    checked: _vm._q(_vm.snoozeDuration, "7")
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.snoozeDuration = "7"
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "b-radio" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "name" }, [
                                  _vm._v("7 days")
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("fieldset", { staticClass: "b-vspace-s" }, [
                            _c("label", { staticClass: "checkbox radio" }, [
                              _c("span", { staticClass: "time-icon" }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.snoozeDuration,
                                    expression: "snoozeDuration"
                                  }
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "snooze_days",
                                  value: "30"
                                },
                                domProps: {
                                  checked: _vm.snoozeDuration == 30,
                                  checked: _vm._q(_vm.snoozeDuration, "30")
                                },
                                on: {
                                  change: function($event) {
                                    _vm.snoozeDuration = "30"
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "b-radio" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "name" }, [
                                _vm._v("1 month")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.reminder.snooze_duration_days
                            ? _c("fieldset", [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-flat snooze-disable-trigger",
                                    on: { click: _vm.turnOffSnooze }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Turn snooze off\n            "
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "footer",
                        [
                          _c(
                            "Button",
                            {
                              staticClass: "btn btn-outline",
                              attrs: { loading: _vm.saveInProgress },
                              on: { click: _vm.save }
                            },
                            [_vm._v("Save")]
                          )
                        ],
                        1
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }